module.exports = __webpack_public_path__ + "bc9c0fdfa53baf0e571a62bfb4b5d2a4.pdf";